import script from "./volumenesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./volumenesForm.vue?vue&type=script&setup=true&lang=js"

import "./volumenesForm.vue?vue&type=style&index=0&id=0188cc7a&scoped=true&lang=css"
import "./volumenesForm.vue?vue&type=style&index=1&id=0188cc7a&lang=css"
import "./volumenesForm.vue?vue&type=style&index=2&id=0188cc7a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0188cc7a"]])

export default __exports__